import { BadRequest, GenericError, NoDataFound, NotAuthorizeError } from "../../ErrorType";

export const getTopic = async () => {
  let response = await fetch(`${window.bf_globals.apibase}/customerportal/enquiry/topic`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    }
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const getField = async (topic) => {
  let response = await fetch(`${window.bf_globals.apibase}/customerportal/enquiry/field`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce,
    },
    body : JSON.stringify({topic: topic})
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const getAssets = async (topic, field) => {
  let response = await fetch(`${window.bf_globals.apibase}/customerportal/enquiry/assets`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce,
    },
    body : JSON.stringify({
      topic: topic,
      field : field
    })
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const getMessage = async (topic, field, assets) => {
  let response = await fetch(`${window.bf_globals.apibase}/customerportal/enquiry/message`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce,
    },
    body : JSON.stringify({
      topic: topic,
      field : field,
      assets: assets
    })
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const getForms = async (slug) => {
  let response = await fetch(`${window.bf_globals.apibase}/customerportal/enquiry/form?slug=${slug}`, {
    method: 'GET',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce,
    }
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const createEnquiry = async (form) => {
  let response = await fetch(`${window.bf_globals.apibase}/apigateway/enquiry`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    },
    body : JSON.stringify(form)
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const getEnquiries = async () => {
  let response = await fetch(`${window.bf_globals.apibase}/apigateway/enquiry`, {
    method: 'GET',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    }
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const getEnquiryDetails = async (enquiryId) => {
  let response = await fetch(`${window.bf_globals.apibase}/apigateway/enquiry_details?enquiryId=${enquiryId}`, {
    method: 'GET',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    }
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const createComment = async (form) => {
  let response = await fetch(`${window.bf_globals.apibase}/apigateway/enquiry/comment`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    },
    body : JSON.stringify(form)
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const getAttachment = async (enquiryId, attachmentId) => {
  let response = await fetch(`${window.bf_globals.apibase}/apigateway/enquiry/attachment?enquiryId=${enquiryId}&attachmentId=${attachmentId}`, {
    method: 'GET',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    }
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}

export const createAttachment = async (formData) => {
  let response = await fetch(`${window.bf_globals.apibase}/apigateway/enquiry/attachment`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'X-WP-Nonce': window.bf_globals.nonce 
    },
    body: JSON.stringify(formData)
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new NotAuthorizeError();
    } else if (response.status === 404) {
      throw new NoDataFound();
    } else if (response.status === 400) {
      throw new BadRequest();
    } else {
      throw new GenericError();
    }
  }
  let data = await response.json();
  return data;
}
